<v-autocomplete
  hide-details
  density="compact"
  variant="outlined"
  label="Lifecycle"
  :items="lifecycles"
  v-model="lifecycle"
  @update:model-value="$emit('change', $event)"
></v-autocomplete>
